<template>
  <div class="site-wrapper">
    <NavBar />
    <HeroSection />
    <WhatIOfferSection />
    <AboutSection />
    <QualificationsTrainingSection />
    <TherapyRoomSection />
    <SessionsSection />
    <ContactSection />
    <FooterSection />
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue'
import NavBar from '@/components/NavBar.vue'
import WhatIOfferSection from '@/components/WhatIOfferSection.vue'
import AboutSection from '@/components/AboutSection.vue'
import QualificationsTrainingSection from '@/components/QualificationsTrainingSection.vue'
import TherapyRoomSection from '@/components/TherapyRoomSection.vue'
import SessionsSection from '@/components/SessionsSection.vue'
import ContactSection from '@/components/ContactSection.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: {
    HeroSection,
    NavBar,
    WhatIOfferSection,
    AboutSection,
    QualificationsTrainingSection,
    TherapyRoomSection,
    SessionsSection,
    ContactSection,
    FooterSection
  }
}
</script>

<style>
/* Base Styles */
*,
::before,
::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Web Fonts */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap');

:root {
  /* Enhanced color palette with warm, professional tones */
  --site-navy: #1E3A5F;
  --site-terracotta: #D2919A;
  --site-terracotta-light: #E5BFA8;
  --site-offwhite: #FAF9F7;
  --site-text: #333333;
  --site-text-light: #333333;
  --site-text-dark: #1a202c;
  --site-border: #D2919A;
  
  /* Font families */
  --font-heading: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  
  /* Base font size responsive */
  --font-size-base: clamp(1rem, 0.95rem + 0.25vw, 1.125rem);
}

/* Global Tailwind-extended styles */
.site-wrapper {
  font-family: var(--font-body);
  color: var(--site-text);
  background-color: #fff;
  line-height: 1.6;
  font-size: var(--font-size-base);
  transition: padding-top 0.3s ease;
  overflow-x: hidden;
}

.font-poppins {
  font-family: var(--font-heading);
}

/* Custom utility classes for the color palette */
.text-site-navy {
  color: var(--site-navy);
}

.text-site-terracotta {
  color: var(--site-terracotta);
}

.text-site-text {
  color: var(--site-text);
}

.text-site-text-light {
  color: var(--site-text-light);
}

.text-site-text-dark {
  color: var(--site-text-dark);
}

.bg-site-navy {
  background-color: var(--site-navy);
}

.bg-site-terracotta {
  background-color: var(--site-terracotta);
}

.bg-site-terracotta-light {
  background-color: var(--site-terracotta-light);
}

.bg-site-offwhite {
  background-color: var(--site-offwhite);
}

.border-site-border {
  border-color: var(--site-border);
}

/* Focus states for accessibility */
button:focus, 
a:focus {
  outline: 2px solid var(--site-terracotta);
  outline-offset: 2px;
}

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}

/* Global section styles */
section {
  position: relative;
}

/* Global animation classes */
.fade-in {
  animation: fadeIn 0.5s ease forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.slide-up {
  animation: slideUp 0.5s ease forwards;
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ensure consistent rendering across browsers */
button,
input,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

/* Utility classes for transitions */
.transition-300 {
  transition: all 0.3s ease;
}

.transition-500 {
  transition: all 0.5s ease;
}

/* Fix for iOS 100vh issue */
@supports (-webkit-touch-callout: none) {
  .h-screen {
    height: -webkit-fill-available;
  }
}
</style>
